<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            配置下载
        </div>
        <div style="padding: 20px;">

            <div class="setGov">
                <div style="height: 10px;"></div>

                <div :style="contentStyleObj">
                    <template>
                        <el-row class="setBody">
                            <el-col :span="24" class="item" style="text-align:center">
                                <h2>{{GovName}}</h2>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-card class="box-card card" shadow='hover'>
                                    <div slot="header" class="clearfix">
                                        <span>app二维码</span>
                                        <el-button type="primary" icon="el-icon-download"  class="setButton" plain @click="downloadQZ">下载</el-button>
                                    </div>
                                    <el-col :span="24" style="text-align:center">
                                        <img id="QzImg" style="width: 50%; height: 50%" :src="qzurl"/>
                                    </el-col>
                                </el-card>
                            </el-col>
                        </el-row>
                    </template>
                </div>

            </div>

        </div>
        <LevelTree ref="myLevelTree" v-show="showModalLevelTree" v-on:showModal="showModal" v-bind:listZoneDTO="listZoneDTO" v-on:setLevel="setLevel"></LevelTree>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import LevelTree from "./LevelTree"

    export default {
        name: "Set",
        components:{LevelTree},
        data() {
            return {

                spLoading:false,
                dialogFormVisible:false,
                GovName:'',
                governmentCode:'',
                listZoneDTO:[],
                showModalLevelTree:false,
                level:'',
                levelName:'未设置',
                topRoleName:'未设置',
                roleCode:'',
                roleValue:[],
                lvName:'',
                qzurl:'',
                url:'',
                th:0,
                contentStyleObj: {
                    padding:'0px',
                    backgroundColor:'#fff',
                    overflowY:'auto',
                    height: ''
                },
            }
        },
        created(){
            this.init();
            this.th = this.$store.state.tableHeight;
            this.contentStyleObj.height = this.th +50 +"px";

        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
                this.contentStyleObj.height = this.th+50 +"px";
            },
        },


        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/Get",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        // this.loading = false;
                        if (response.data.error == 0) {
                            this.GovName = response.data.data.name;
                            this.governmentCode = response.data.data.governmentCode;
                            this.level = response.data.data.elderlyLastAuditZoneLevel;
                            this.topRoleName = response.data.data.roleName;
                            this.roleCode = response.data.data.topRoleCode;
                            this.menuShow();
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }

                    }
                )
                this.getDownloadQZ()
            },
            menuShow(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Role/ListGov",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            console.log(response.data.data)
                            var roleValue = response.data.data;
                            var index=-1;
                            for (var i = 0; i < roleValue.length; i++) {
                                if (roleValue[i].name == '商家') index=i;
                            }
                            roleValue.splice(index, 1);
                            this.roleValue=roleValue
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            downloadQZ(){
                this.downloadByBlob('乐庭关爱二维码.png')
            },
            downloadByBlob(name) {
                var u=this.url.replace(/\\/g,'/')
                    this.$axios.get(this.$shopUrl+'Upload/ReadImg?url='+u,{
                        responseType: 'blob',
                    }).then(    
                        (response) => {
                            this.downloadFile(response.data, name);
                        }
                    )
            },
            downloadFile(content, filename) {
                var a = document.createElement('a')
                var blob = new Blob([content])
                var url = window.URL.createObjectURL(blob)
                a.href = url
                a.download = filename
                document.body.appendChild(a);
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a);
            },
            download(href, name) {
                let eleLink = document.createElement('a')
                eleLink.download = name
                eleLink.href = href
                eleLink.click()
                eleLink.remove()
            },
            append() {
                this.showModalLevelTree = !this.showModalLevelTree;
                this.$refs.myLevelTree.init();
            },
            role() {
                this.dialogFormVisible =true;
            },
            getDownloadQZ(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"QRCode/GetImg",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.qzurl=this.$imgUrl+response.data.data
                            this.url=response.data.data
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            showModal() {
                this.showModalLevelTree = !this.showModalLevelTree;
            },
            setRole(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/SetRole",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        topRoleCode: this.roleCode,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            console.log( response.data.data.name)
                            this.init();
                            this.dialogFormVisible = false
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            updateMune(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/EditLastAuditZoneLevel",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        governmentCode: this.governmentCode,
                        level: this.level,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            // console.log( response.data.data.name)
                            this.levelName=this.level+"级"+this.lvName[this.level];
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
            setLevel(level){
                this.level=level
                // this.levelName=level+"级"+this.lvName[level];
                this.updateMune();
            }

        },

    }

</script>


<style lang="scss" scoped>

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        padding-right: 8px;
    }
    .el-button--text{
        font-size: 16px;
    }
    .el-tree-node__content{
        height: auto;
    }
    .sp{
        margin-right: 20px;
    }
    .setBody .el-card__body{
        padding:10px 20px;
    }
    // .card{
    //     height: 150px;
    // }
    .setButton{
        float: right;
        transform: translate(0px, -9px);
    }
    .setGov /deep/ .el-dialog{
        border-radius: 10px;
    }
</style>

